var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointerCarYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3034_19873)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 12,
    fill: "#FDE047"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4582 15.0417H20.8748C21.2998 15.0417 21.5832 14.7583 21.5832 14.3333V12.2083C21.5832 11.5708 21.0873 11.0042 20.5207 10.8625C19.2457 10.5083 17.3332 10.0833 17.3332 10.0833C17.3332 10.0833 16.4123 9.09168 15.7748 8.45418C15.4207 8.17084 14.9957 7.95834 14.4998 7.95834H9.5415C9.1165 7.95834 8.76234 8.24168 8.54984 8.59584L7.55817 10.65C7.46437 10.9236 7.4165 11.2108 7.4165 11.5V14.3333C7.4165 14.7583 7.69984 15.0417 8.12484 15.0417H9.5415",
    stroke: "#713F12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9582 16.4583C11.7406 16.4583 12.3748 15.8241 12.3748 15.0417C12.3748 14.2593 11.7406 13.625 10.9582 13.625C10.1758 13.625 9.5415 14.2593 9.5415 15.0417C9.5415 15.8241 10.1758 16.4583 10.9582 16.4583Z",
    stroke: "#713F12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.0417H16.625",
    stroke: "#713F12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0417 16.4583C18.8241 16.4583 19.4583 15.8241 19.4583 15.0417C19.4583 14.2593 18.8241 13.625 18.0417 13.625C17.2593 13.625 16.625 14.2593 16.625 15.0417C16.625 15.8241 17.2593 16.4583 18.0417 16.4583Z",
    stroke: "#713F12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3034_19873",
    x: 0,
    y: 0,
    width: 28,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3034_19873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3034_19873",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointerCarYellow);
export default __webpack_public_path__ + "static/media/map_pointer_car_yellow.415136d0864c22d84ea56b5ca7f5275b.svg";
export { ForwardRef as ReactComponent };